import { FC, memo } from 'react'
import { SpaceProps } from 'styled-system'
import { VehicleLabel } from '..'
import { StyledVehicles } from './Vehicles.style'

export interface VehiclesProps extends SpaceProps {
  data?: {
    number?: number
    type?: string
    text?: string
  }[]
  fullWidth?: boolean
  variant?: 'default' | 'alternative' | 'light'
}

const Vehicles: FC<VehiclesProps> = ({ data, fullWidth, variant }) => {
  return (
    <StyledVehicles fullWidth={fullWidth} variant={variant}>
      {data?.map?.((item, index) => {
        return <VehicleLabel key={index} type={item?.type || ''} text={item?.text} variant={variant} />
      })}
    </StyledVehicles>
  )
}

const areEqual = (prev: VehiclesProps, next: VehiclesProps) => {
  return JSON.stringify(prev) === JSON.stringify(next)
}

export default memo(Vehicles, areEqual)
